import type { AvailableCountries } from '~/types/country';
import type { RouterConfig } from '@nuxt/schema';
import { useRequestURL, useState } from 'nuxt/app';
import { useCountrySwitch } from '../composables/useCountrySwitch';

export default <RouterConfig>{
    routes(_routes) {
        const rewrite = useState('rewrite', () => true);
        const country = useState<AvailableCountries>('country', () => 'de');
        const config = useRuntimeConfig();

        if (!rewrite.value && import.meta.server) return _routes;

        const { countryConfig } = useCountrySwitch();

        const { href } = useRequestURL();

        const matchingCountryConfigKey =
            (Object.keys(countryConfig) as AvailableCountries[]).find(prefix => href.indexOf(`/${prefix}/`) !== -1) ??
            'de';

        const matchedContry = countryConfig[matchingCountryConfigKey];

        _routes.map(route => {
            if (!route?.originalPath) {
                route.originalPath = route.path;
            }

            if (route?.originalPath) {
                route.path = route.originalPath;
            }

            // Early exit if the route was already modified
            if (matchedContry.prefix.length && route.path.indexOf(`${matchedContry.prefix}/`) !== -1) return route;

            // Remove old modifications from route path
            route.path = route.path.replace('/fr/', '/');
            route.path = route.path.replace('/com/', '/');

            // Prepend the country specific prefix
            route.path = `${matchedContry.prefix}${route.path}`;

            // remove the translation prefix for the default locale of the current country
            if (route.path.indexOf(matchedContry.defaultLocale) !== -1) {
                route.path = route.path.replace(`/${matchedContry.defaultLocale}`, '');
            }

            return route;
        });

        country.value = matchingCountryConfigKey;

        config.public.pond.accessToken = matchedContry.accessToken;

        rewrite.value = false;

        return _routes;
    },
    scrollBehavior(to, from, savedPosition) {
        const scrollPosition = useState('scrollPosition', () => 0);

        if (scrollPosition.value) {
            savedPosition = {
                top: scrollPosition.value,
                left: 0,
            };
            scrollPosition.value = null;
        }

        if (savedPosition) {
            return savedPosition;
        }

        return {
            top: 0,
        };
    },
};
